import ProfileArticleHeader from './ProfileArticleHeader'
import ProfileArticleContent from './ProfileArticleContent'
interface Author {
  id: number
  name: string
  bio: string
  author_type: string
  avatar: string
  linkedin_url: string | null
}

export interface Article {
  id: number
  tags: string[]
  areas: string[]
  sub_areas: string[]
  author: Author
  views_count: number
  sector: string
  created_at: string
  updated_at: string
  uuid: string
  slug: string | null
  title: string
  summary: string
  content: string
  publish_date: string
  cover_image: string
  type: string
  is_featured: boolean
  legal_services: string[]
}

interface ProfileArticleProps {
  article: Article
}

function ProfileArticle({ article }: ProfileArticleProps) {
  return (
    <div
      key={article.id}
      className='h-[371px] w-[330px] mx-auto flex   flex-col items-start rounded-[10px] bg-[#FFF] shadow-[0px_4px_16px_0px_rgba(0,0,0,0.06)]'
    >
      <ProfileArticleHeader
        image={article.cover_image}
        publishDate={article.publish_date}
      />
      <ProfileArticleContent
        summary={article?.summary}
        tags={article?.tags}
        avatar={article?.author?.avatar}
        name={article?.author?.name}
        type={article?.author?.author_type}
      />
    </div>
  )
}

export default ProfileArticle
